// @flow
import useDebouncedCallback from './useDebouncedCallback';

export type ThrottleOptions = {|
  leading?: boolean,
  trailing?: boolean,
|};
const useThrottledCallback = <T: (...args: any[]) => any>(
  fn: T,
  throttle: number,
  options?: ThrottleOptions,
): T =>
  useDebouncedCallback(fn, throttle, {
    leading: true,
    trailing: true,
    maxWait: throttle,
    ...options,
  });
export default useThrottledCallback;
